import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class NewsRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getHomeNews() {
    throw new Error('[NewsRepository#getHomeNews] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getNewsSuggestions() {
    throw new Error('[NewsRepository#getNewsSuggestions] must be implemented')
  }

  /**
   * @param {Object} deps
   * @param {String} deps.term
   * @param {String} deps.category
   * @return {Error}
   */
  getNews({tag = '', category = '', searchTerm = ''} = {}) {
    throw new Error('[NewsRepository#getNews] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  subscribeToNewsletter() {
    throw new Error('[NewsRepository#subscribeToNewsletter] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getVehicleNews() {
    throw new Error('[NewsRepository#getVehicleNews] must be implemented')
  }
}
